//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';
import Papa from 'papaparse';
import { useListableProperties } from '@/api/legacy/useListableProperties';
import { saveFile } from '@/helpers/util';

export default {
  name: 'DpTreeViewSettings',
  props: {
    visible: { type: Boolean, default: false },
    locked: { type: Boolean, default: false },
    columns: { type: Array, default: null },
    rows: { type: Array, default: null },
  },
  setup() {
    const { listableProperties } = useListableProperties();
    return { listableProperties };
  },
  data() {
    return {
      searchText: null,
    };
  },
  computed: {
    shownProperties() {
      const { searchText } = this;
      const availableProperties = this.listableProperties;
      const usedProperties = !this.columns ? [] : this.columns.map((col) => col.property);

      const properties = availableProperties.map((prop) => ({
        ...prop,
        used: usedProperties.includes(prop.name),
      })).filter((prop) => !prop.isOnline);
      if (!searchText) return properties;

      const search = searchText.toLowerCase();
      return properties.filter((prop) => prop.alias.toLowerCase().includes(search));
    },
  },
  methods: {
    setDragData(ev, type, field) {
      const data = {
        type,
        field,
      };

      ev.dataTransfer.setData('text/plain', JSON.stringify(data));
    },
    toggleProperty(property) {
      const event = property.used ? 'remove-column' : 'add-column';
      this.$emit(event, {
        type: 'data',
        label: property.alias,
        field: property.name,
        date: property.isTs,
      });
    },
    exportAsCsv() {
      const { rows, columns } = this;
      const exportData = rows.map((row) => {
        const returnedDatum = {};

        columns.forEach((col) => {
          if (col.type === 'data') {
            let data = row[col.property];
            if (col.date && data) {
              const m = moment(data);
              if (m.isValid()) {
                data = m.toDate().toLocaleString().replace(',', '');
              }
            }
            returnedDatum[col.label] = data;
          } else if (col.type === 'kpi') {
            const kpi = row[col.kpi];
            returnedDatum[col.label] = kpi ? kpi.displayY0 : null;
          } else if (col.type === 'identifier') {
            returnedDatum[col.label] = row[col.property];
          }
        });

        return returnedDatum;
      });

      const csv = Papa.unparse(exportData);
      const blob = new Blob([
        new Uint8Array([0xEF, 0xBB, 0xBF]), // set UTF-8 BOM
        csv,
      ], { type: 'text/csv;charset=utf-8' });

      saveFile(blob, 'tableData.csv');
    },
  },
};
